import {
    Alert
} from "@amzn/awsui-components-console";

export function DeprecationMessage() {
    
    return (
        <Alert statusIconAriaLabel="Warning" type="warning">
            <b>PANN Dashboard is on the path to deprecation</b> and self-service scans may no longer be initiated. If you are a builder with PANN scanning requirements or a feature request, please create a <a href="https://t.corp.amazon.com/create/templates/145b55db-a984-48e4-a09a-54091ad5ffb1">SIM ticket</a> and <a href="https://w.amazon.com/bin/view/DigitalSecurity/SBS_Vuln_Risk_Services/NBT_Detections/">NBT Detections</a> will review your business use case.
            <br/><br/><br/>
            <Alert statusIconAriaLabel="Info" type="info">
                For immediate help with PANN scanning, please create a <a href="https://t.corp.amazon.com/create/templates/29a86fa0-40ed-4ce6-9e56-47615c1f0407">Scan Request</a> and NBT Detections will follow up offline with PANN applicability results.
            </Alert>
        </Alert>
    )
}